// ********************************************************
// License stuff
//
// ********************************************************

// TODO Should be a backend call for getting claims

export const adminNo = '10'
export const adminName = 'Admin'

export const corporateAdminNo = '40'
export const corporateAdminName = 'Corporate Admin'

export const deliveryInspectionNo = '69171005'
export const deliveryInspectionName = 'Delivery Inspection'

export const wheelLoaderNo = '69171010'
export const wheelLoaderName = 'Wheel Loader'

export const reportsNo = '69171015'
export const reportsName = 'Reports'
export const reportsSimpleNo = '691710151'
export const reportsSimpleName = 'ReportsSimple'

export const asphaltDeliveryVehicleNo = '691710201'
export const asphaltDeliveryVehicleName = 'Asphalt Delivery Vehicle'
export const asphaltDeliveryCarrierNo = '691710202'
export const asphaltDeliveryCarrierName = 'Asphalt Delivery Carrier'

export const preRegistrationNo = '69171025'
export const preRegistrationName = 'Pre-Registration'

export const classifierNo = '69171030'
export const classifierName = 'Classifier'

export const scanCodeNo = '69171035'
export const scanCodeName = 'Scan Code'

export const nominationNo = '69171040'
export const nominationName = 'Nomination'

export const unloadingFuelNo = '69171045'
export const unloadingFuelName = 'Unloading Fuel'

export const batchRegistrationNo = '69171050'
export const batchRegistrationName = 'Batch Registration'

export const scanMobileNo = '69171055'
export const scanMobileName = 'Scan Mobile'

export const storageMapNo = '69171060'
export const storageMapName = 'Storage Map'

export const apiImportExportNo = '69171065'
export const apiImportExportName = 'Api Import Export'

export const worlPlacesNo = '69171070'
export const worlPlacesName = 'Workplaces'

export const createVehiclesNo = '69171075'
export const createVehiclesName = 'Create Vehicles'
